import React from "react";

import { ICommonProps } from "@plex/react-components/dist/esm/components/Common.types";

import { ValidationMessage } from "@plex/react-components";

import { ILocalizable } from "infrastructure/localization";
import { useLocalizerWithFallback } from "ui/hooks";

import styles from "./ValidatableElement.module.scss";

export interface IValidationIssue {
  message?: ILocalizable | string;
}

export interface IValidation {
  hideError?: boolean;
  validationIssue?: IValidationIssue;
}

export interface IValidatableElementProps<TValue> {
  value: TValue;
  validation: IValidation;
  render: (currentValue: TValue, props: ICommonProps) => React.ReactNode;
}

export function ValidatableElement<TValue>({ render, value, validation }: IValidatableElementProps<TValue>): React.ReactElement<IValidatableElementProps<TValue>> {
  const localizeWithFallback = useLocalizerWithFallback();
  const message = localizeWithFallback(validation.validationIssue?.message);
  const hasError = !!message || validation.validationIssue != null;

  return (
    <>
      {render(value, { className: hasError && !validation.hideError ? styles.invalid : undefined })}

      {message && !validation.hideError && <ValidationMessage message={message} />}
    </>
  );
}
